<template>
  <div class="common-box margin-l6 border-t0">
    <el-row class="row-one">
      <span class="row-one-title">密码修改</span>
    </el-row>
    <el-form :model="passChangeForm" status-icon :rules="passChangeFormRules" ref="passChangeFormRef" label-width="100px" label-position="right" class="form-single">
      <el-form-item prop="name" style="display:none;">
        <el-input v-model="passChangeForm.name"></el-input>
      </el-form-item>
      <el-form-item label="原密码：" prop="oldPass" class="margin-t70">
        <el-input class="inputThree" ref="oneRef" type="password" v-model="passChangeForm.oldPass" placeholder="请输入原密码" @input="passChangeForm.oldPass = passChangeForm.oldPass.trim()" autoComplete="new-password" show-password></el-input>
      </el-form-item>
      <el-form-item label="新密码：" prop="newPass">
        <el-input class="inputThree" type="password" v-model="passChangeForm.newPass" placeholder="请输入新的交易密码" @input="passChangeForm.newPass = passChangeForm.newPass.trim()" autoComplete="new-password" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" prop="confirePass">
        <el-input class="inputThree" type="password" v-model="passChangeForm.confirePass" placeholder="请再次输入交易密码" @input="passChangeForm.confirePass = passChangeForm.confirePass.trim()" autoComplete="new-password" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <div class="el-form-item__error warnColor" style="width:350px;line-height: 20px;">注：密码长度为6-8位，不能含有3个及以上重复相同、连续数字或字母、空格或者汉字</div>
      </el-form-item>
      <el-form-item>
        <el-button type="normal" class="margin-t50" @click="submit">修改密码</el-button>
      </el-form-item>
    </el-form>

    <!-- 密码修改成功弹框 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable" :show-close="false" :close-on-click-modal="false">
      <img src="../../../assets/images/2021_dg.png" alt="" width="60">
      <p class="dialog-single-one-p" style="padding: 0px 48px;">恭喜，您的密码已被修改，请采用新的密码进行登录</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="loginAgain">重新登录</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  data () {
    var validatePass1 = (rule, value, callback) => {
      var req = /(\w)\1{2}/;
      var reString = /^[\u4E00-\u9FA5]+$/;
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.search(req) != -1) {
        callback(new Error('密码内不能含有3个连续相同的字符！'));
      } else if (!this.$commonJs.checkSeries(value)) {
        callback(new Error('密码不能有三个以上(含三个)的连续数字或字母！'));
      } else if (reString.test(value)) {
        callback(new Error('密码不能有汉字！'));
      } else {
        if (this.passChangeForm.confirePass !== '') {
          this.$refs.passChangeFormRef.validateField('confirePass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passChangeForm.newPass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var checkPass = (rule, value, callback) => {
      var req = /(\w)\1{2}/;
      var reString = /^[\u4E00-\u9FA5]+$/;
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.search(req) != -1) {
        callback(new Error('密码内不能含有3个连续相同的字符！'));
      } else if (!this.$commonJs.checkSeries(value)) {
        callback(new Error('密码不能有三个以上(含三个)的连续数字或字母！'));
      } else if (reString.test(value)) {
        callback(new Error('密码不能有汉字！'));
      } else {
        callback();
      }
    };
    return {
      passChangeForm: {
        name: '',
        oldPass: '',
        newPass: '',
        confirePass: ''
      },
      passChangeFormRules: {
        oldPass: [
          { validator: checkPass, trigger: 'blur' },
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, max: 8, message: '密码位数必须为6～8位！', trigger: 'blur' }

        ],
        newPass: [
          { required: true, message: '请输入新的交易密码', trigger: 'blur' },
          { min: 6, max: 8, message: '密码位数必须为6～8位！', trigger: 'blur' },
          { validator: validatePass1, trigger: 'blur' }
        ],
        confirePass: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 6, max: 8, message: '密码位数必须为6～8位！', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ],
      },
      dialogVisable: false,
    }
  },
  mounted () {

  },
  methods: {
    submit () {
      this.$refs.passChangeFormRef.validate(valid => {
        if (!valid) return
        var inputpwd = this.$des.enString(this.passChangeForm.oldPass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
        var reallypass = this.$commonJs.getCookie('Password')
        if (inputpwd != reallypass) {
          this.$message.error('原密码输入错误')
        } else {
          this.$http.post(this.$apiPath.resetTPassword, {
            // sessionId: this.$commonJs.getCookie('sessionid'),
            certificateno: Base64.decode(this.$commonJs.getCookie('u_id')),//证件号码
            accttype: '',
            certificatetype: '0',
            newpwd: this.$des.enString(this.passChangeForm.newPass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
          }).then(res => {
            if (res.data.code == "200" && res.data.success) {
              this.dialogVisable = true
            } else {
              this.$message.error('密码修改失败')
            }
          }).catch(err => { })
        }

      })

    },
    loginAgain () {
      this.$commonJs.logout()
      this.$router.push({ name: 'login' })
    },
  }
}
</script>


